<template>
  <b-row>
    <b-col md="12">
      <b-card>
        <b-row>
          <b-col sm="12">
            <b-form-group
              label="포스트 제목"
              label-for="basicText"
              :label-cols="1"
              :horizontal="true">
              <b-row class="pt-sm-12">
                <b-col sm="12">
                  <b-form-input id="basicText" type="text" v-model="queryParams.postsubject" v-on:keyup="$event.keyCode === 13 ? findMainManagementList() : ''" placeholder="검색어를 입력해주세요."></b-form-input>
                </b-col>
              </b-row>
            </b-form-group>
            <hr class="mt-0">
            <b-form-group
              label="등록일"
              label-for="basicStatic"
              :label-cols="1"
              :horizontal="true">
              <b-row class="pt-sm-12">
                <b-col sm="2"><b-form-input type="text" name="daterange" :disabled="queryParams.day_code == 'dayall'" /></b-col>
                <b-col sm="5">
                  <b-button class="mx-1"
                  variant="outline-primary"
                  v-for="(dateMonthBtn, idx) in dateMonthButtons"
                  v-on:click="dateMonthSelect(dateMonthBtn)"
                  :key="idx"
                  :pressed.sync="dateMonthBtn.state">
                    {{ dateMonthBtn.item_name }}
                  </b-button>
                </b-col>
              </b-row>
            </b-form-group>
            <hr class="mt-0">
            <b-form-group
              label="활성화"
              label-for="basicText"
              :label-cols="1"
              :horizontal="true">
              <b-row class="pt-sm-12">
                <b-col sm="12">
                  <label class="col-form-label">
                    <b-form-radio-group
                      id="payorder-group"
                      v-model="queryParams.active_yn"
                      :options="[
                        {text: '전체',value: 'all'},
                        {text: '활성',value: 'Y'},
                        {text: '비활성',value: 'N'},
                      ]"
                      name="payorder-options"
                    ></b-form-radio-group>
                  </label>
                </b-col>
              </b-row>
            </b-form-group>
            <div style="float:right">
              <b-button type="submit" variant="success" v-on:click="findMainManagementList()"><i class="fa fa-dot-circle-o"></i> 검색</b-button>
            </div>
          </b-col>
        </b-row>
      </b-card>
    </b-col>

    <b-col md="12">
      <b-card>
        <b-row>
          <b-col sm="12">
            <span class="card-title wise-card-title">검색 기준 </span>
          </b-col>
          <b-col sm="12">
            <b-row>
              <b-col sm="1">
              </b-col>
              <b-col sm="4">
                <div class="callout callout-success"><span class="text-muted"  style="font-size:15px">포스트제목</span><br> <strong class="h4">{{searchData.postsubject == undefined || searchData.postsubject == '' ? '미입력' : searchData.keyword}}</strong></div>
              </b-col>
              <b-col sm="4">
                <div class="callout callout-warning"><span class="text-muted"  style="font-size:15px">등록일</span><br>
                  <strong class="h4" v-if="searchData.dayAllCheck">전체</strong>
                  <strong class="h4" v-if="!searchData.dayAllCheck">{{searchData.startday}} ~ {{searchData.endday}}</strong>
                </div>
              </b-col>
              <b-col sm="3">
                <div class="callout callout-info"><span class="text-muted" style="font-size:15px">활성화</span><br> <strong class="h4">{{searchData.typeCodeName == undefined || searchData.typeCodeName == '' ? '미입력' : searchData.typeCodeName}}</strong></div>
              </b-col>
            </b-row>
            <hr class="mt-0">
          </b-col>
        </b-row>
      </b-card>

      <b-card>
        <b-row>
          <b-col sm="12">
            <b-row>
              <b-col sm="4">
                <span class="pr-"><strong>총 {{items.length}}건</strong></span>
              </b-col>
              <b-col sm="3"></b-col>
              <b-col sm="3"></b-col>
              <b-col md="2" class="my-1">
                <b-form-group label-cols-sm="5" label="" class="mb-0">
                  <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="12" class="pt-sm-1">
            <b-row>
              <b-col sm="1"></b-col>
              <b-col sm="12">
                <b-table
                  striped
                  hover
                  :fields="fieldItems"
                  :items="items"
                  :busy="items == 0"
                  :current-page="currentPage"
                  :per-page="perPage">
                  <div slot="table-busy" class="text-center my-2">
                    <strong>데이터가 없습니다.</strong>
                  </div>
                  <template slot="postsubject" slot-scope="data">
                    <div><a href="javascript:void(0)" v-on:click="mainBannerInfoGo(data.item)">{{data.item.postsubject}}</a></div>
                  </template>
                  <template slot="slot_number" slot-scope="data">
                    <div style="width:100px">
                      <select :id="'slotSelect'+data.item.rnum" size="0" class="form-control" v-if="data.item.active_yn == 'Y'" v-on:change="slotOnChange(data.item, $event.target.value, data.item.rnum)">
                        <option v-for="optItem in selectSlotNumbers" :value="optItem.banner_code+'|'+optItem.slot_number+'|'+optItem.postsubject" :selected="optItem.slot_number == data.item.slot_number">{{optItem.slot_number}}</option>
                        <!-- <option value="2" :selected="2 == data.item.slot_number">2</option>
                        <option value="3" :selected="3 == data.item.slot_number">3</option>
                        <option value="4" :selected="4 == data.item.slot_number">4</option>
                        <option value="5" :selected="5 == data.item.slot_number">5</option> -->
                      </select>
                      <div v-if="data.item.active_yn == 'N'">비활성</div>
                    </div>
                  </template>
                  <template slot="bannerdate" slot-scope="data">
                    {{data.item.start_date}} ~ {{data.item.end_date}}
                  </template>
                  <template slot="active_yn" slot-scope="data">
                    <div><c-switch type="text" :id="'activeSelect'+data.item.rnum" variant="primary" v-model="data.item.active_yn" v-on:change="bannerActiveYN(data.item, data.item.rnum)" on="On" off="Off" :pill="true" :checked="true" style="margin:0px"/></div>
                  </template>
                </b-table>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="12" class="pt-sm-1">
            <b-row class="pb-sm-2">
              <b-col sm="1"></b-col>
              <b-col sm="12" class="my-1">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="listRows"
                  :per-page="perPage"
                  align="center"
                ></b-pagination>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <div style="float:right">
          <b-button variant="info" style="color:#ffffff" v-bind:href="'#/main/mainmanagement/form?status=insert'"><i class="fa fa-hand-o-up"></i> 신규등록</b-button>
        </div>
      </b-card>
    </b-col>
  </b-row>



</template>
<script>
import datetimepicker from "daterangepicker/daterangepicker.js";
import { codeAPI } from '../../common/code.js';
import swal from 'sweetalert2'
import cSwitch from '../../components/Switch'

const moment = require("moment");

export default {
  components: {
    cSwitch
  },
  data() {
    return {
      reporturltype: this.$route.params.reporturltype,
      banner_type: '',
      dr_topdeth_code: '',
      dr_rtype: '',
      slotNumValue: null,
      selectSlotNumbers: [],
      resultCateDatas: [], // code.js 각 코드들의 결과값
      selectCateItems: [], // 상단 구분 셀렉트 박스 코드값
      myToggle: false,
      // totalRows: 30,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 30, 50, 100],
      drDeleteRows: [],
      searchData: {},
      queryParams: {
        day_code: 'dayall',
        start_date: moment().add(0, 'days').format('YYYY-MM-DD'),
        end_date: moment().format('YYYY-MM-DD'),
      },
      slotParams:{},
      fieldItems: [{
        'rnum': {
          'label': '번호',
          'class': 'text-center',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      }, {
        'postsubject': {
          'label': '포스트제목',
          'thStyle': {
             'vertical-align': 'middle',
             'text-align': 'center'
          }
        }
      }, {
        'slot_number': {
          'label': '슬롯번호',
          'class': 'text-center',
          'thStyle': {
             'vertical-align': 'middle',
             'text-align': 'center',
             'width':'100px'
          }
        }
      }, {
        'bannerdate': {
          'label': '활성기간',
          'class': 'text-center',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      }, {
        'reg_date': {
          'label': '등록일',
          'class': 'text-center',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      }, {
        'active_yn': {
          'label': '활성화',
          'class': 'text-center',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      }, {
        'reg_name': {
          'label': '최총 등록자',
          'class': 'text-center',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      }],
      items: [],
      dateMonthButtons: [
        { item_name: '전체', item_code:'dayall', state: true },
        { item_name: '오늘', item_code:'-1|days',state: false },
        { item_name: '1주일', item_code:'-7|days',state: false },
        { item_name: '1개월', item_code:'-1|months',state: false },
        { item_name: '6개월', item_code:'-6|months',state: false },
        { item_name: '1년', item_code:'-1|years',state: false },
      ],
      calendarLocale: {
        "format": "YYYY-MM-DD",
        "separator": "~",
        "applyLabel": "적용",
        "cancelLabel": "취소",
        "fromLabel": "From",
        "toLabel": "To",
        "customRangeLabel": "Custom",
        "weekLabel": "W",
        "daysOfWeek": [
          "일", "월", "화", "수", "목", "금", "토"
        ],
        "monthNames": [
          "1월", "2월", "3월", "4월", "5월", "6월",
          "7월", "8월", "9월", "10월", "11월", "12월"
        ],
        "firstDay": 1
      },
    }
  },
  computed: {
    listRows() {
      return this.items.length
    }
  },
  watch: {
    'slotNumValue' (newValue, oldValue) {
      // console.log(newValue);
      // console.log(oldValue);
    },
  },
  mounted: function() {
     // /contents/trendbrief
     this.mainManagementInit();
  },
  methods: {
    mainManagementInit() {
      var token = sessionStorage.getItem("myToken");
      var self = this;

      self.searchData = {};
      self.queryParams = {
        active_yn: 'all',
        day_code: 'dayall',
        banner_type: 'mainbanner',
        start_date: moment().add(0, 'days').format('YYYY-MM-DD'),
        end_date: moment().format('YYYY-MM-DD'),
      };

      self.dateMonthButtons.forEach(function (el, idx, arr){
        if(idx == 0){
          el.state = true;
        }else{
          el.state = false;
        }
      });

      // 최초 리스트 갱신
      self.findMainManagementList();

      $(function() {
        $('input[name="daterange"]').daterangepicker({
          opens: 'left',
          "locale": self.calendarLocale,
          "endDate": moment().format('YYYY-MM-DD'),
          "startDate": moment().add(0, 'days').format('YYYY-MM-DD')
        }, function(start, end, label) {
          self.queryParams.start_date = start.format('YYYY-MM-DD');
          self.queryParams.end_date = end.format('YYYY-MM-DD');
        });
      });
    },
    // 메소드명 : findMainManagementList()
    // ### 메인배너 리스트 조회 ###
    // 메인배너 리스트를 DB테이블에서 조회한다.
    //
    // 최초작성 : 2016.05.31
    // 파라미터 :
    //  - banner_type(배너 종류 값)
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2020.08.21  황경현   최초작성
    // *************************
    findMainManagementList() {
      var self = this;
      var token = sessionStorage.getItem("myToken");
      var param = encodeURI(JSON.stringify(self.queryParams));

      var data = new FormData();
      data.append('objs', param);

      self.$http.post('/api/select/mainManagementList?access_token=' + token, data, null)
        .then((result) => {
          self.items = result.data;
          var itemCnt = self.items.length;
          self.selectSlotNumbers = [];
          self.items.forEach(function (el, idx, arr){
            el.rnum = itemCnt - (idx);
            el.selectchecked = false;
            if(el.active_yn == 'Y'){
              self.selectSlotNumbers.push(el);
            }
          });
          self.searchData.startday = self.queryParams.start_date;
          self.searchData.endday = self.queryParams.end_date;
          self.searchData.dayAllCheck = self.queryParams.day_code == 'dayall';
        })
    },
    mainBannerInfoGo(row) {
      var self = this;
      self.$session.set('bannercode', row.banner_code);
      location.href = '#/main/mainmanagement/form?status=update';
    },
    slotOnChange(data, value, selectNum){
      var self = this;
      var token = sessionStorage.getItem("myToken");
      var items = data;
      var preSlotNumArr = value.split("|");
      if(data.slot_number != preSlotNumArr[1]){
        swal.fire({
          title: '순서 설정!',
          html: "<strong>이전 순서 - "+preSlotNumArr[2]+"("+preSlotNumArr[1]+")</br>변경 순서 - "+items.postsubject+"(<span style='color:red'>"+items.slot_number+" => "+preSlotNumArr[1]+"</span>)</strong></br>변경 하시겠습니까?",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'OK'
        }).then((swalResult) => {
          if (swalResult.value) {
            self.slotParams.banner_code = items.banner_code;
            self.slotParams.slot_number = items.slot_number;
            self.slotParams.old_banner_code = preSlotNumArr[0];
            self.slotParams.old_slot_number = preSlotNumArr[1];
            var param = encodeURI(JSON.stringify(self.slotParams));
            var data = new FormData();
            data.append('objs', param);

            console.log(self.queryParams);
            self.$http.post('/api/update/slotNumbers?access_token='+token, data, null)
              .then((result) => {
                swal.fire({
                  type: 'success',
                  title: '순서가 설정되었습니다.',
                  showConfirmButton: false,
                  timer: 1000
                }).then(function() {
                    $("#slotSelect"+selectNum).val(items.banner_code+'|'+items.slot_number+'|'+items.postsubject);
                    self.findMainManagementList();
                });
            })
          }else{
            $("#slotSelect"+selectNum).val(items.banner_code+'|'+items.slot_number+'|'+items.postsubject);
          }
        })
      }
    },
    bannerActiveYN(data, selectNum){
      var self = this;
      var token = sessionStorage.getItem("myToken");
      var items = data;
      var oldActive = (items.active_yn == 'Y'?'N':'Y');
      var newActive = items.active_yn;
      if(oldActive == 'N' && self.selectSlotNumbers.length == 5){
        data.active_yn = oldActive;
        $("#activeSelect"+selectNum).find("input:checkbox[class='switch-input']").prop("checked", false);
        swal.fire(
          '배너 사용은 최대 5개까지 입니다.',
          '',
          'error'
        ).then(function() {
          self.findMainManagementList();
        });
      }else{
        if(oldActive == 'Y' && self.selectSlotNumbers.length == 1 ){
          data.active_yn = oldActive;
          $("#activeSelect"+selectNum).find("input:checkbox[class='switch-input']").prop("checked", true);
          swal.fire(
            '배너는 최소 1개 이상<br/> 게재되어야 합니다!',
            '',
            'warning'
          ).then(function() {
            self.findMainManagementList();
          });
        }else{
          self.$http.get('/api/update/bannerActiveYn?access_token='+token + '&bannercode='+items.banner_code + '&newactive='+newActive+'&banner_type=mainbanner')
          .then((result) => {
            // swal.fire(
            //   '적용 되었습니다.',
            //   '',
            //   'success'khhw
            // ).then(function() {
            //
            // });
            self.findMainManagementList();
          })
        }
      }
    },
    dateMonthSelect (item) {
      var self = this;
      self.dateMonthButtons.forEach(function (el, idx, arr){
        if(el.item_code == item.item_code){
          el.state = true;
        }else{
          el.state = false;
        }
      });
      // { item_name: '전체', item_code:'dayall', state: true },
      // { item_name: '오늘', item_code:'1|days',state: false },
      // { item_name: '1주일', item_code:'7|days',state: false },
      // { item_name: '1개월', item_code:'1|months',state: false },
      // { item_name: '6개월', item_code:'6|months',state: false },
      // { item_name: '1년', item_code:'1|years',state: false },
      self.queryParams.day_code = item.item_code;
      var addDateCnt = 0;
      var dateSpilt;
      dateSpilt = item.item_code.split("|");
      setTimeout(function(){
        $('input[name="daterange"]').data('daterangepicker').setStartDate(moment().add(dateSpilt[0], dateSpilt[1]).format('YYYY-MM-DD'));
  		  $('input[name="daterange"]').data('daterangepicker').setEndDate(moment().format('YYYY-MM-DD'));
        self.queryParams.start_date = moment().add(dateSpilt[0], dateSpilt[1]).format('YYYY-MM-DD');
        self.queryParams.end_date = moment().format('YYYY-MM-DD');
      }, 0);
    },
  },
}

function reportCodeReturn(urlcode){
  // trendbrief
  // indepthreport
  // surveyreport
  // visualbrief
  var reportCodeDatas = {};
  if(urlcode == 'trendbrief'){
    reportCodeDatas.depth_top_name = '트렌드브리프';
    reportCodeDatas.dr_topdeth = 'RPT_TYPE_1';
    reportCodeDatas.dr_unique = 'TB';
  }else if(urlcode == 'indepthreport'){
    reportCodeDatas.depth_top_name = '인뎁스리포트';
    reportCodeDatas.dr_topdeth = 'RPT_TYPE_2';
    reportCodeDatas.dr_unique = 'IR';
  }else if(urlcode == 'surveyreport'){
    reportCodeDatas.depth_top_name = '서베이리포트';
    reportCodeDatas.dr_topdeth = 'RPT_TYPE_3';
    reportCodeDatas.dr_unique = 'SR';
  }else if(urlcode == 'visualbrief'){
    reportCodeDatas.depth_top_name = '비쥬얼브리프';
    reportCodeDatas.dr_topdeth = 'RPT_TYPE_4';
    reportCodeDatas.dr_unique = 'VB';
  }
  return reportCodeDatas;
}
</script>
<style lang="css" scoped>
  .delete_button_on {color:#ffffff; border-radius:5px; cursor:pointer; border:1px solid #f42f2d; font-size:15px}
  .delete_button_off {color:#ffffff; border-radius:5px; cursor:auto; border:1px solid #f42f2d; font-size:15px}
  .clear_button_on {color:#ffffff; border-radius:5px; cursor:pointer; border:1px solid #55a0bb; font-size:15px}
  .clear_button_off {color:#ffffff; border-radius:5px; cursor:auto; border:1px solid #55a0bb; font-size:15px}
</style>
<style src="daterangepicker/daterangepicker.css">



// WEBPACK FOOTER //
// src/views/main/MainManagementList.vue